import React from 'react'
import { FaBars } from 'react-icons/fa'
import logo from '../../assets/newLogo.png'
import * as styles from './publicNavbar.styles'
const PublicNavbar = () => {
    return (
        <div className={styles.container}>
            <img src={logo} className={styles.img}/>
            
        </div>
    )
}

export default PublicNavbar
